export const relatedProductsGql = /* GraphQL */ `
... on bodyContent2022_productPageRelatedProducts_BlockType {
    typeHandle
    displayViewAllLink
    displayFilters
    filterCategoryDepth
    relatedProducts:productPageRelatedProducts {
        ... on product_productPage2022_Entry {
            uri
            title
            relatedProductDescription
            relatedProductTitle
            productCategories(orderBy: "lft asc") {
                id
                level
                categoryTitle:title
                url
            }
            productFeaturedImage {
                ... on images_Asset {
                    title
                    galleryEnlarged {
                        srcWebp
                        srcset
                    }
                }
                ... on productImages_Asset {
                    title
                    galleryEnlarged {
                        srcWebp
                        srcset
                    }
                }
            }
        }
        ... on product_productPage_Entry {
            uri
            title
            relatedProductDescription
            relatedProductTitle
            productCategories(orderBy: "lft asc") {
                id
                level
                categoryTitle:title
                url
            }
            productFeaturedImage {
                ... on images_Asset {
                    title
                    galleryEnlarged {
                        srcWebp
                        srcset
                    }
                }
                ... on productImages_Asset {
                    title
                    galleryEnlarged {
                        srcWebp
                        srcset
                    }
                }
            }
        }
    }
}`;
